import React from 'react';
import styled from 'styled-components';
import Moment from 'moment'
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux'
import {ToolbarWithLogo} from '../../Components/Toolbar';
import ContainerPage, {Routes} from "../ContainerPage";
import {getInstantOptions, resetWizard, setDateOption, toggleDayPart,} from '../Welcome/Actions';
import {BottomWrapper, CoreWrapper, TopWrapper} from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import Select from "../../Components/Select";
import ProgressTracker from "../../Components/ProgressTracker";
import MultiSelect from "../../Components/MultiSelect";
import Sizes from "../../Assets/Sizes";
import H2 from "../../Components/H2";
import StaticDatePicker from "../../Components/StaticDatePicker";
import InstantOptions from "../../Components/InstantOptions";
import {CSSTransition} from "react-transition-group";
import {ASAP_DATE, SPECIFIC_DATE} from "../Welcome/Reducer";
import {genericDate} from "../../Common/Helpers";
import Toast from "../../Components/Toast";
import AppointmentApprovalDialog from "../../Components/AppointmentApprovalDialog";
import {Checkbox} from "rmwc";
import H1 from "../../Components/H1";
import {PROGRESS_KEY} from "../../Common/constants";
import {getSafely, valueOrDefault} from "@tomeravni/easybizy-js-common/common";


const CheckBoxWrapper = styled.div`
    margin-right: -${Sizes.mediumPadding};
    margin-left: -${Sizes.mediumPadding};
    margin-top: ${Sizes.mediumPadding};

    a {
        color: ${p => p.theme.colors.primaryText};
    }

    label {
        color: ${p => p.theme.colors.primaryText};
    }

`;


const ContentWrapper = styled.div`
    width: 100%;
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};
`;

const InstantWrapper = styled.div`
    width: 100vw;
    padding-right: ${Sizes.defaultPadding};
    padding-top: ${Sizes.defaultPadding};
    overflow-x: scroll; /* has to be scroll, not auto */
    -webkit-overflow-scrolling: touch;
`;

const MyTopWrapper = styled(TopWrapper)`
    .appear-enter {
        opacity: 0;
        z-index: 9;
        transform: translateX(-100%);
    }

    .appear-enter-active {
        z-index: 9;
        opacity: 1;
        transition: opacity 500ms, transform 500ms;
        transform: translateX(0);

    }
`;

const SelectWrapper = styled.div`
    width: 100%;
    height: auto;
`;

const InstantOptionsSection = styled.div`
    z-index: 3;
    position: relative;

`;

const InstantContent = styled.div`
    opacity: ${p => p.hidden ? 0 : 1};
    visibility: ${p => p.hidden ? 'hidden' : 'visible'};
    transition: ${p => p.hidden ? 'all 500ms' : 'none'};
`;

const InstantOptionsMask = styled.div`
    z-index: 1;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 750ms;
    visibility: ${p => p.visible ? 'visible' : 'hidden'};
    opacity: ${p => p.visible ? 1 : 0};
`;

const InstantOptionsClose = styled.div`
    position: absolute;
    margin-top: -${Sizes.largeIcon};
    width: 100%;
    text-align: center;
    z-index: 100;

    > button {
        color: ${p => p.theme.colors.primaryText};
        font-size: ${Sizes.largeFontSizeButton};
        border: ${Sizes.thickBorderButton} solid ${p => p.theme.colors.primaryText};
        cursor: pointer;
        background: transparent;
        padding: ${Sizes.smallMargin} ${Sizes.defaultPadding};
    }
`;

class PickTime extends ContainerPage {
    state = {didRequestInstantOptions: false, didWait: false, showDayPartPicker: false};

    constructor(props) {
        super(props);
        this.nextRoute = Routes.results;
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.scheduledMeeting) {
            this.props.resetWizard();
            this.startOver();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.config && nextProps.config.AllowPickingEmployees && !nextProps.employee) {
            this.navigate(Routes.pickEmployee)
        } else if (!this.state.didRequestInstantOptions && nextProps.config && nextProps.services) {
            setTimeout(() => {
                this.safeSetState({didWait: true});
            }, 1500);
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        super.componentWillUpdate(nextProps, nextState, nextContext);
        if (this.instantOptionsError && !nextState.instantOptionsErrorWasVisible) {
            this.setState({instantOptionsErrorWasVisible: true}, () => {
                this.showToastMessage(this.instantOptionsError);
            })
        }

    }

    dateSelected(date) {
        this.props.setDateOption(genericDate(date));
        setTimeout(() => {
            this.goToSchedulingRoute();
        }, 300);
    }

    isDayDisabled(date) {
        const daysOfWork = this.props.daysOfWork;
        if (!Array.isArray(daysOfWork) || !date) {
            return false;
        }

        return !daysOfWork[date.getDay()];
    }

    dateOptionPicked(option) {
        this.props.setDateOption(null);
        if (option.datePicker) {
            return this.datePicker.show();
        }

        this.props.setDateOption(option.value);
        this.goToSchedulingRoute();
    }


    get dateOption() {
        const date = this.props.stateParams && this.props.stateParams.date;
        let toReturn = null;
        if (date) {
            if (date === ASAP_DATE.value) {
                toReturn = ASAP_DATE;
            } else {
                toReturn = SPECIFIC_DATE;
            }
        }

        return toReturn ? toReturn.value : null;
    }

    toggleTimeOption(option) {
        // Cannot uncheck single option
        if (option.checked && this.props.timingOptions.filter(opt => (opt.value !== option.value && opt.checked)).length === 0) {
            return;
        }

        this.props.toggleDayPart(option);
    }

    confirmAndCreateMeeting(option) {
        this.confirmDialog.confirm(option).then((result) => {
            this.done(result);
        })
            .catch((err) => {
                let errorMessage = 'Unknown Error';
                if (err.message) {
                    try {
                        errorMessage = this.props.intl.formatMessage({id: err.message});
                    } catch (e) {
                        // Ignore
                    }
                }

                this.showToastMessage(errorMessage);
            })
    }

    goToSchedulingRoute() {
        this.next();
    }

    hideInstantOptions = () => {
        this.setState({hideInstantOptions: true})
    };

    render() {
        const hasInstantOptions = this.props.instantOptions && this.props.instantOptions.length > 0;
        const showInstantOptions = !this.state.hideInstantOptions && this.state.didWait && this.state.didRequestInstantOptions && hasInstantOptions;
        const currentProgressIndex = valueOrDefault(this.props.progress, []).findIndex((p) => p.label === PROGRESS_KEY.TIME_ALIGNMENT) || 0;
        const ltr = !this.props.intl.locale.includes('he');
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';

        return (
            <div className="transition-item detail-page detail-page__pick-time">
                <CoreWrapper padding={true} loading={!this.props.config} ltr={ltr}>
                    <ToolbarWithLogo imageUri={toolbarLogo} ltr={ltr} rootUri={this.getRoutePrefix()}>
                        <ProgressTracker progress={this.props.progress} current={currentProgressIndex}
                                         visible={true}/>
                    </ToolbarWithLogo>

                    <MyTopWrapper justify="start" align="start" padding={true}>
                        {this.state.delayed &&
                            <SelectWrapper>
                                <ContentWrapper>
                                    <H1><FormattedMessage id="schedule.findMeAppointment"/></H1>
                                </ContentWrapper>
                                <Select
                                    ltr={ltr}
                                    selected={this.dateOption}
                                    onClick={(option) => this.dateOptionPicked(option)}
                                    items={this.props.datingOptions} keyProp="value"
                                    preventPaddingBottom={true}
                                    nameProp="label"/>
                            </SelectWrapper>}
                        {this.state.delayed && <ContentWrapper>

                            <CheckBoxWrapper>
                                <Checkbox
                                    checked={this.state.showDayPartPicker}
                                    onChange={evt => this.setState({showDayPartPicker: evt.target.checked})}>
                                    <FormattedMessage id="schedule.pickDayPart"/>
                                </Checkbox>
                            </CheckBoxWrapper>

                            {this.state.showDayPartPicker &&
                                <div>
                                    <H2><FormattedMessage id="schedule.timeAtDay"/></H2>
                                    <MultiSelect options={this.props.timingOptions}
                                                 toggleOption={(option) => this.toggleTimeOption(option)}
                                                 ltr={ltr}
                                    />

                                </div>
                            }
                        </ContentWrapper>}

                        <InstantOptionsMask visible={showInstantOptions} onClick={this.hideInstantOptions}/>
                        <CSSTransition
                            in={showInstantOptions}
                            unmountOnExit
                            timeout={1500}
                            classNames="appear">
                            <InstantContent hidden={this.state.hideInstantOptions}>
                                <InstantOptionsClose>
                                    <button onClick={this.hideInstantOptions}><FormattedMessage id="app.close"/>
                                    </button>
                                </InstantOptionsClose>
                                <InstantOptionsSection>
                                    <ContentWrapper>
                                        {this.state.didMount &&
                                            <H2><FormattedMessage id="schedule.foundInstantOptionsHeader"/></H2>}
                                    </ContentWrapper>
                                    <InstantWrapper>
                                        {this.state.delayed &&
                                            <InstantOptions items={this.props.instantOptions}
                                                            itemSelected={(option) => this.confirmAndCreateMeeting(option)}/>}
                                    </InstantWrapper>
                                </InstantOptionsSection>
                            </InstantContent>
                        </CSSTransition>

                        {this.state.delayed &&
                            <StaticDatePicker
                                innerRef={(r) => this.datePicker = r}
                                minDate={new Date()} value={new Date()}
                                dateSelected={(date) => this.dateSelected(date)}
                                shouldDisableDate={(date) => this.isDayDisabled(date)}
                                maxDate={Moment().add(2, 'year').toDate()}/>}

                    </MyTopWrapper>
                    <BottomWrapper empty={true}>
                        <PoweredBy/>
                    </BottomWrapper>
                </CoreWrapper>
                <Toast ref={(toast) => this.toast = toast}/>
                <AppointmentApprovalDialog
                    innerRef={(confirmDialog) => this.confirmDialog = confirmDialog}/>
            </div>
        )
    }
}

/** Styled-Components **/
/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingServices,
        config: state.schedule.configWithServices,
        progress: state.schedule.progress,
        services: state.schedule.services,
        employee: state.schedule.employee,
        timingOptions: state.schedule.timingOptions,
        datingOptions: state.schedule.datingOptions,
        instantOptions: state.schedule.instantOptions,
        stateParams: state.schedule.stateParams,
        dayPart: state.schedule.stateParams ? state.schedule.stateParams.day_part : null,
        date: state.schedule.stateParams ? state.schedule.stateParams.date : null,
        daysOfWork: state.schedule.daysOfWork,
        scheduledMeeting: state.schedule.scheduledMeeting
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleDayPart: (option) => dispatch(toggleDayPart(option)),
        setDateOption: (option) => dispatch(setDateOption(option)),
        getInstantOptions: (serviceIds, employeeId) => dispatch(getInstantOptions(serviceIds, employeeId)),
        resetWizard: () => dispatch(resetWizard())

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PickTime));
